import axios from "axios";
import SessionService from "../_services/session.service";
import { store } from "../_store/root-store";
import { showError } from "../_reducers/alert.reducer";
import { hide, show } from "../_reducers/loader.reducer";
import handleError from "./handler-exception";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

const setupAxiosInterceptors = (dispatch: any) => {
  api.interceptors.request.use(
    (config) => {
      dispatch(show());
      const accessToken = SessionService.getAccessToken();
      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  api.interceptors.response.use(
    (response) => {
      dispatch(hide());
      return response.data;
    },
    async (error) => {
      if (error.response) {
        handleError(error);
        // The request was made, but the server responded with a status code
        console.error(
          "Response Error:",
          error.response.status,
          error.response.data
        );
        dispatch(showError(error.response.data?.message));
      } else if (error.request) {
        console.error("Request Error:", error.request);
        dispatch(showError(error.message));
      } else {
        // Dispatch your error action
        dispatch(showError(error.message));
      }
      dispatch(hide());
      // return Promise.reject(error);
    }
  );
};
setupAxiosInterceptors(store.dispatch);
export { api, setupAxiosInterceptors };
